import {PERMIT_APPLICATION_STATUS} from "permitapplication/data";
import {usePermitExtensionProcessUrl} from "permitextension/hooks";
import {DateUtil} from "base/format/utilities";
import {PaperContainer} from "base/ui/containers";
import {PermitTypeTags} from "permit/presentational";
import {TextLink} from "base/navigation/components";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Badge from "@mui/material/Badge";

// TODO(cmartin): merge with permit summary, everything is the same except for hook
const PermitExtensionSummary = ({entity, basePath}) => {
    const {getStepPath} = usePermitExtensionProcessUrl(entity);
    const statusPath = getStepPath(entity, basePath);

    return (
        <PaperContainer
            sx={{
                width: "100%",
                flexWrap: "nowrap",
                py: 2,
                backgroundColor: "secondary.lighter",
                color: "secondary.dark",
            }}
        >
            <Grid item container xs={2.5}>
                <Typography variant="overline" mr={1}>
                    Data de solicitação:
                </Typography>
                <Typography variant="overline" fontWeight={500}>
                    {DateUtil.formatDate(entity?.application_date)}
                </Typography>
            </Grid>
            {entity?.holder?.name ? (
                <Grid item container xs pl={1}>
                    <Typography variant="overline" mr={1}>
                        Titular:
                    </Typography>
                    <Typography variant="overline" fontWeight={500}>
                        {entity?.holder?.name}
                    </Typography>
                </Grid>
            ) : null}
            <Grid item container xs flexWrap="nowrap" alignItems="center">
                <Divider orientation="vertical" variant="middle" flexItem />
                {entity?.status === PERMIT_APPLICATION_STATUS.not_approved ? (
                    <Typography
                        variant="overline"
                        fontWeight={500}
                        color="error.dark"
                        pl={2}
                    >
                        {entity?.status}
                    </Typography>
                ) : (
                    <Badge color="warning" variant="dot">
                        <TextLink
                            text={entity?.status}
                            to={statusPath}
                            textStyle={{
                                pl: 2,
                                fontSize: "0.75rem",
                                letterSpacing: "0.08333em",
                                textTransform: "uppercase",
                                fontWeight: "500",
                                color: "secondary.dark",
                            }}
                        />
                    </Badge>
                )}
            </Grid>
            <Grid item container xs justifyContent="flex-end">
                {entity?.types?.length ? (
                    <PermitTypeTags types={entity?.types} />
                ) : null}
            </Grid>
        </PaperContainer>
    );
};

export default PermitExtensionSummary;
